import api from "api";
import * as constants from "./actionTypes";

// TODO: need to migrate all users away from this to api-v1 or v2
function getApiWithToken() {
	return api;
}

export const getAccountTypes = () => {
	return async (dispatch) => {
		(async () => {
			const accountTypes = await getApiWithToken().get("account-types").json();
			await dispatch({
				type: constants.GET_ACCOUNT_TYPES,
				payload: accountTypes.data,
			});
		})();
	};
};

export const getLegacyAccountTypes = () => {
	return async (dispatch) => {
		(async () => {
			const accountTypes = await getApiWithToken()
				.get("account-types/legacy")
				.json();
			await dispatch({
				type: constants.GET_ACCOUNT_TYPES,
				payload: accountTypes.data,
			});
		})();
	};
};
